import { QueryOperation, SearchQuery } from "../../code/search-query/search-query";
import { buildSearchQuery, dateRangeValue, QueryFieldMapping } from "../../code/search-query/query-mapper";
import { DataColumn } from "../../controls/Data.default";
import { DynamicSchema } from "../../controls/DynamicForm.default";

export interface LabelsForm {
  readonly uid?: string;
  readonly rowVersion?: string;
  readonly name: string;
  readonly description: string;
  readonly createdByUserUserName: string;
  readonly createdOn: string;
  readonly updatedByUserUserName: string;
  readonly updatedOn: string;
}

export const LabelsViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 120,
    sort: true,
    defaultSort: "asc",
  },
  {
    title: "Description",
    key: "description",
    width: 640,
    sort: true,
  },
  {
    title: "Created By",
    key: "createdByUserUserName",
    width: 192,
    sort: true,
  },
  {
    title: "Created On",
    key: "createdOn",
    width: 192,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Updated By",
    key: "updatedByUserUserName",
    width: 192,
    sort: true,
  },
  {
    title: "Updated On",
    key: "updatedOn",
    width: 192,
    format: "DD/MM/YYYY HH:mm",
    sort: true,
  },
];

const labelsQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "description", operation: QueryOperation.Contains },
  { formField: "createdByUserUserName" },
  { formField: "createdOn", operation: QueryOperation.Between, transform: dateRangeValue },
  { formField: "updatedByUserUserName" },
  { formField: "updatedOn", operation: QueryOperation.Between, transform: dateRangeValue },
];

export const mapLabelsViewQuery = (values: LabelsForm): SearchQuery =>
  buildSearchQuery(values, labelsQueryMappings);

export const labelsSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "name", label: "Name" },
        { type: "textbox", name: "description", label: "Description" },
        { type: "textbox", name: "createdByUserUserName", label: "Created By" },
        { type: "rangetimepicker", name: "createdOn", label: "Created On" },
        { type: "textbox", name: "updatedByUserUserName", label: "Updated By" },
        { type: "rangetimepicker", name: "updatedOn", label: "Updated On" },
      ],
    },
  ],
};
